import { useEffect, useState } from "react";
import QRCode from "qrcode";

interface QrCodeProps {
  value: string;
  size?: number;
  className?: string;
  alt?: string;
}

export default function QrCode({
  value,
  size = 120,
  className = "",
  alt = "رمز الاستجابة السريعة",
}: QrCodeProps) {
  const [src, setSrc] = useState("");
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let active = true;
    setFailed(false);
    QRCode.toDataURL(value, {
      margin: 1,
      width: size * 2,
      errorCorrectionLevel: "M",
      color: { dark: "#000000", light: "#ffffff" },
    })
      .then((url) => {
        if (active) setSrc(url);
      })
      .catch(() => {
        if (active) {
          setSrc("");
          setFailed(true);
        }
      });
    return () => {
      active = false;
    };
  }, [value, size]);

  return (
    <div
      className={`flex items-center justify-center rounded-btn border border-background-200 bg-white p-2 ${className}`}
      style={{ width: size + 16, height: size + 16 }}
    >
      {src ? (
        <img
          src={src}
          alt={alt}
          title={alt}
          style={{ width: size, height: size }}
          className="object-contain"
        />
      ) : (
        <div
          className={`w-full h-full rounded-box flex items-center justify-center text-foreground-300 ${
            failed ? "bg-background-50" : "yc-skeleton"
          }`}
        >
          {failed && <i className="ri-qr-code-line text-2xl"></i>}
        </div>
      )}
    </div>
  );
}